import React from 'react'
import { Link } from 'react-router'

import Header from './header'

export default function FourOhFour() {
    return (
        <div>
            <Header title="Page not found" />

            <div className="content">
                <div className="content__inner">
                    <div className="box">
                        <div className="box__content box__content--padded">
                            Sorry, the page you were looking for could not be found. Please try
                            going to the <Link to="/">home page</Link>.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// ./app/components/404.js